(function () {
	'use strict';

	angular
		.module('wizard-future7.constants')
		.constant('PATHS', {
			PHYSICAL: '/app/src/angular'
		})
		.constant('ROUTES', {
			APP: 'https://localhost:3000/',
			APP_DEV: 'https://www-dev.future7.com.br',
			API: 'https://www-dev.future7.com.br/api',
			API_GROWTH: 'https://growth.wizard.com.br/api',
			OAUTH_BASE_ADDRESS: 'https://minhasfranquias.pearson.com.br/'
		})
		.constant('OAUTH_KEYS', {
			CLIENT_ID: '0qJIoOACIDtkYM4h1cbwkv3XpDi3XZ05RM3M8FRf'
		})
}());